import Image from 'next/legacy/image';

import letter from '/public/images/graduate/letter.webp';
import { youtubeUrlConverter } from '@/lib/utils/businessLogics/utils/_helper';

import * as D from './data';
import * as S from './style';

export default function Project({
  graduateName,
  project,
}: {
  graduateName: string;
  project: {
    nameService: string;
    descService: string;
    urlVideo: string;
  };
}) {
  const projectUrl = project ? youtubeUrlConverter(project.urlVideo) : '';
  // const projectUrl = "";
  const letterText = D.ManagerLetter.replaceAll('수료생', graduateName);

  return (
    <S.Wrapper>
      {projectUrl === '' || !projectUrl ? (
        <>
          <S.Title>매니저님의 편지 💌</S.Title>
          <S.Letter>
            <Image src={letter} layout='fill' objectFit='cover' />
            <S.LetterText>{letterText}</S.LetterText>
          </S.Letter>
        </>
      ) : (
        <>
          <S.Title>{graduateName}님의 대표작 🏆</S.Title>
          <S.ProjectVideo>
            <iframe
              src={`${projectUrl}`}
              width='100%'
              height='100%'
              style={{ border: 'none' }}
              allowFullScreen={true}
              title='graduate_video'
              loading='lazy'
            />
          </S.ProjectVideo>
          <S.ProjectTitle>{project.nameService}</S.ProjectTitle>
          <S.ProjectDesc>{project.descService}</S.ProjectDesc>
        </>
      )}
    </S.Wrapper>
  );
}
